<template>
  <div>
    <v-card-title class="dialog_header">{{ formTitle }}</v-card-title>
    <v-card-text>
      <v-form @submit.prevent="handleSubmit">
        <formWrapper :validator="$v.form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <locale-select
                  v-if="isEdit"
                  v-model="locale"
                  @change="changeLocale"
                />
                <form-group name="name" attribute="fields.name">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model="form.name"
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>

              <v-col cols="12">
                <v-btn
                  :loading="loadingButton"
                  type="submit"
                  :disabled="$v.form.$invalid"
                  class="primary"
                  >{{ textButton }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </formWrapper>
      </v-form>
    </v-card-text>
  </div>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { ShowData } from "@/helpers/apiMethods";
import cookie from "js-cookie";
export default {
  name: "FormAction",

  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    table_ref: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: "",
    },
  },
  data() {
    return {
      form: {
        name: "",
      },
      reset: false,
      loadingButton: false,
      locale: this.locale,
    };
  },
  computed: {
    formTitle() {
      if (this.isEdit) {
        return this.$t("headings.edit");
      } else {
        return this.$t("headings.create");
      }
    },
    textButton() {
      if (!this.isEdit) {
        return this.$t("button.create");
      } else {
        return this.$t("button.edit");
      }
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.resetData();
        }
      },
      immediate: true,
    },
    isEdit: {
      handler(value) {
        if (value) {
          this.handleShowData();
        }
      },
      immediate: true,
    },
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50),
      },
    },
  },
  methods: {
    hanleRefreshTable() {
      this.table_ref.handleGetItems(this.$route.query);
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },

    resetData() {
      this.$v.form.$reset();
      this.form.name = "";
      this.reset = true;
      this.loadingButton = false;
      this.locale = cookie.get("language");
    },
    handleSubmit() {
      this.loadingButton = true;
      const formData = new FormData();

      Object.keys(this.form).forEach((formKey) => {
        formData.append(formKey, this.form[formKey]);
      });
      if (!this.isEdit) {
        // in case create
        this.table_ref
          .handleOnCreate(
            `countries/${this.$route.params.id}/cities`,
            formData,
            "city"
          )
          .finally(() => {
            this.loadingButton = false;
          });
      } else {
        // in case edit
        formData.append("_method", "put");
        formData.append("locale", this.locale);
        this.table_ref
          .handleOnEdit(
            `countries/${this.$route.params.id}/cities`,
            formData,
            this.item.id,
            "city",
            this.index
          )
          .finally(() => (this.loadingButton = false));
      }
    },
    handleShowData(locale = this.locale) {
      ShowData({
        reqName: `countries/${this.$route.params.id}/cities`,
        param: this.item.id,
        locale,
      })
        .then((res) => {
          const { city } = res.data;
          this.form = city;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
